import React from "react";
import SupportLayout from "../../support/SupportLayout";
import AdminBusinessesContent from "./AdminBusinessesContent";

const AdminBusiness = () => {
  return (
    <SupportLayout userRole="ADMIN">
      <AdminBusinessesContent useOwnLayout={false} userRole="ADMIN" />
    </SupportLayout>
  );
};

export default AdminBusiness;
